import en from './locales/en.json'
import es from './locales/es.json'

const locales = {
  en: en,
  es: es
}
export default locales
